import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Accordion,
  Alert,
  Badge,
  Button,
  Card,
  Checkbox,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  Radio,
  Spinner,
  TabItem,
  Table,
  Tabs,
} from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { ADMIN, CATEGORIES, QUERIES, USERS } from "../../config/apiConfig";
import {
  formatToReal,
  isOlderThan30Days,
  isOlderThan7Days,
  parseJSON,
} from "../../utils/utils";
import { IoIosCheckmarkCircleOutline, IoMdSearch } from "react-icons/io";
import AutoCompleteInput from "../inputs/Autocomplete";
import EmptyTable from "./EmptyTable";
import {
  MdEdit,
  MdErrorOutline,
  MdExpandMore,
  MdLocalPrintshop,
  MdOutlineAttachMoney,
  MdOutlineDisplaySettings,
  MdOutlinePageview,
  MdPersonSearch,
  MdReceiptLong,
} from "react-icons/md";
import { BsFillBarChartFill } from "react-icons/bs";
import DrawerLoading from "../DrawerLoading";
import { useApplication } from "../../contexts/ApplicationContext";
import { Tooltip } from "react-tooltip";
import { useReactToPrint } from "react-to-print";
import CustomCreditQueryReview from "../queries/CustomCreditQueryReview";
import CustomVehicleQueryReview from "../queries/CustomVehicleQueryReview";
import { LuFilter, LuFilterX } from "react-icons/lu";
import ModalEditPrice from "../modals/ModalEditPrice";
import TableLoading from "../TableLoading";
import { FaMoneyBillWave } from "react-icons/fa";
import CustomCadastralQueryReview from "../queries/CustomCadastralQueryReview";

const AdminHistoryTable = ({ isActive = true }) => {
  const queryClient = useQueryClient();
  const { userPermission, user } = useApplication();
  const [activeTab, setActiveTab] = useState(1);
  const [activeTabModal, setActiveTabModal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPriceSum, setTotalPriceSum] = useState(0);
  const [totalPriceBase, setTotalPriceBase] = useState(0);
  const [totalCostPrice, setTotalCostPrice] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [selectedQueries, setSelectedQueries] = useState([]);
  const [listCategoryQueries, setListCategoryQueries] = useState([]);
  const [openModalViewDetails, setOpenModalViewDetails] = useState(false);
  const reportRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef: reportRef });
  const [openModal, setOpenModal] = useState(false);
  const [dataQuery, setDataQuery] = useState(null);
  const [selectedQueryReview, setSelectedQueryReview] = useState(null);

  const printRef = useRef();
  const extratoRef = useRef(null);
  const reactToPrintExtrato = useReactToPrint({ contentRef: extratoRef });
  const reactToPrintFnQuery = useReactToPrint({ contentRef: printRef });

  const [selectedCustomer, setSelectedCustomer] = useState({
    label: "Todos os clientes",
    value: 0,
  });
  const [selectedProduct, setSelectedProduct] = useState({
    label: "Todos os produtos",
    value: 0,
  });
  const [selectedRepresentative, setSelectedRepresentative] = useState({
    label: "Todos os representantes",
    value: 0,
  });

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedIsModular, setSelectedModular] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [showFilters, setShowFilters] = useState(true);
  const [renderFilters, setRenderFilters] = useState(false);
  const [editPriceModalOpen, setEditPriceModalOpen] = useState(false);
  const [queryToEdit, setQueryToEdit] = useState(null);
  const [newPrice, setNewPrice] = useState("");
  const [openCostModal, setOpenCostModal] = useState(false);
  const [protocolForCost, setProtocolForCost] = useState(null);

  // Métrica das barras no simplificado (mantemos apenas 'count' e 'value')
  const [barMetric, setBarMetric] = useState("count"); // 'count' | 'value'

  // NOVO: filtro "É adicional?"
  const [filterIsAdditional, setFilterIsAdditional] = useState(false); // padrão: false

  useEffect(() => {
    if (showFilters) {
      setRenderFilters(true);
    } else {
      const timeout = setTimeout(() => setRenderFilters(false), 500);
      return () => clearTimeout(timeout);
    }
  }, [showFilters]);

  const activeCompanyId =
    (() => {
      const raw = selectedRepresentative?.value;
      if (raw == null || raw === "" || raw === 0) {
        return Number(user?.companyId) || null;
      }
      const parsed = Number(raw);
      return Number.isNaN(parsed) || parsed <= 0 ? null : parsed;
    })() ?? null;

  const permissionsQueryKey = [
    "companyQueryPermissions",
    activeCompanyId ?? "none",
  ];

  const {
    isLoading: isLoadingCompanyQueryPermissions,
    error: errorCompanyQueryPermissions,
    data: companyQueryPermissions,
  } = useQuery(
    permissionsQueryKey,
    async () => {
      const { data: items } = await axios.get(
        `${ADMIN.GET_COMPANY_QUERIES}/${activeCompanyId}`
      );
      return items?.data ?? [];
    },
    {
      enabled: isActive && !!activeCompanyId,
      keepPreviousData: true,
    }
  );

  const {
    isLoading: isLoadingCustomers,
    error: errorListCustomers,
    data: listCustomers,
  } = useQuery(
    ["listCustomers", selectedRepresentative],
    async () => {
      try {
        const { data } = await axios.get(
          `${ADMIN.GET_CUSTOMERS}?itemsPerPage=-1&representativeId=${
            selectedRepresentative?.value || ""
          }`
        );

        if (!data?.data?.data) {
          throw new Error("Erro ao buscar clientes");
        }

        let customers = data.data.data.map((customer) => ({
          label:
            customer.typeCustomer === "CPF"
              ? customer.name
              : customer.socialReason,
          value: customer.id,
          vcm: customer.vcm,
          typePayment: customer.typePayment,
          credit: customer.credit,
        }));

        customers = [{ label: "Todos os clientes", value: 0 }, ...customers];

        return customers;
      } catch (error) {
        throw new Error(`Erro ao buscar clientes: ${error.message}`);
      }
    },
    { enabled: isActive }
  );

  const {
    isLoading: isLoadingQueries,
    error: errorQueries,
    data: listQueries,
  } = useQuery(
    ["listQueries"],
    async () => {
      try {
        const { data } = await axios.get(`${ADMIN.GET_QUERIES_LIST}`);

        if (!data?.data) {
          throw new Error("Erro ao buscar produtos");
        }

        let customers = data.data.map((customer) => ({
          label: customer.name,
          value: customer.id,
        }));

        customers = [{ label: "Todos os produtos", value: 0 }, ...customers];

        return customers;
      } catch (error) {
        throw new Error(`Erro ao buscar produtos: ${error.message}`);
      }
    },
    { enabled: isActive }
  );

  const {
    isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(["categories", currentPage], async () => {
    const { data } = await axios.get(`${CATEGORIES.GET_ALL}`);
    return data.data.data;
  });

  const {
    isLoading: isLoadingReportQueries,
    isFetching: isFetchingReportQueries,
    error: errorListReportQueries,
    data: listReportQueries,
  } = useQuery(
    [
      "listReportQueries",
      selectedCustomer,
      startDate,
      endDate,
      currentPage,
      selectedStatuses,
      nameParam,
      selectedIsModular,
      selectedProduct,
      selectedRepresentative,
      filterIsAdditional,
    ],
    async () => {
      const { data } = await axios.get(
        `${ADMIN.GET_COMPANY_QUERIES_HISTORY}/${
          selectedCustomer?.value
        }?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&search=${nameParam}&isModular=${selectedIsModular}&queries=${
          selectedProduct?.value
        }&representativeId=${selectedRepresentative?.value}&isAdditional=${
          filterIsAdditional ? "true" : "false"
        }`
      );

      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalPriceSum);
      setTotalCount(data.data.totalCount);
      setTotalPriceBase(data.data.totalPriceSumBase);
      setTotalCostPrice(data.data.totalCostPrice);

      return data.data.data;
    },
    {
      enabled: activeTab === 0 && isActive,
    }
  );

  const {
    isLoading: isLoadingListRepresentatives,
    error: errorListRepresentatives,
    data: listRepresentatives,
  } = useQuery(
    ["listRepresentatives"],
    async () => {
      const { data } = await axios.get(
        `${ADMIN.GET_REPRESENTATIVES}?itemsPerPage=-1`
      );

      const representatives = [
        { label: "Todos os representantes", value: "" },
        {
          label: user?.Company?.name || user?.Company?.socialReason,
          value: user?.companyId,
        },
        ...data.data.data.map((representative) => ({
          value: representative.id,
          label: representative?.name || representative?.socialReason,
        })),
      ];

      return representatives;
    },
    {
      enabled: isActive && !!user,
    }
  );

  const { isLoading: isLoadingProviders, data: providers } = useQuery(
    ["providers"],
    async () => {
      const { data: items } = await axios.get(`${ADMIN.GET_PROVIDERS_ALL}`);
      return items.data;
    },
    { enabled: activeTabModal === 1 }
  );

  const providerNameById = (id) =>
    providers?.find((p) => p.id === id)?.name || (id ? `ID ${id}` : "-");

  const {
    isLoading: isLoadingReportSimplifiedQueries,
    error: errorListReportSimplifiedQueries,
    data: listReportSimplifiedQueries,
    isFetching: isFetchingReportSimplifiedQueries,
  } = useQuery(
    [
      "listReportSimplifiedQueries",
      selectedCustomer,
      startDate,
      endDate,
      currentPage,
      selectedStatuses,
      selectedIsModular,
      selectedProduct,
      selectedRepresentative,
      barMetric, // refetch ao alternar métrica
      filterIsAdditional, // refetch ao alternar filtro de adicional
    ],
    async () => {
      const { data } = await axios.get(
        `${ADMIN.GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED}/${
          selectedCustomer?.value
        }?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&isModular=${selectedIsModular}&queries=${
          selectedProduct?.value
        }&representativeId=${selectedRepresentative?.value}&isAdditional=${
          filterIsAdditional ? "true" : "false"
        }`
      );

      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalSumPrice || 0);
      setTotalCount(data.data.totalSumCount);
      setTotalPriceBase(data.data.totalPriceSumBase);
      setTotalCostPrice(data.data.totalCostPrice);

      return data.data.data;
    },
    {
      enabled: activeTab === 1 && isActive,
    }
  );

  const {
    data: listReportSimplifiedQueriesAll,
    isFetching: isFetchingReportSimplifiedQueriesAll,
  } = useQuery(
    [
      "listReportSimplifiedQueriesAll",
      selectedCustomer,
      startDate,
      endDate,
      selectedStatuses,
      selectedIsModular,
      selectedProduct,
      selectedRepresentative,
      filterIsAdditional,
    ],
    async () => {
      const { data } = await axios.get(
        `${ADMIN.GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED}/${
          selectedCustomer?.value
        }?startDate=${startDate}&endDate=${endDate}&page=1&itemsPerPage=-1&status=${selectedStatuses}&isModular=${selectedIsModular}&queries=${
          selectedProduct?.value
        }&representativeId=${selectedRepresentative?.value}&isAdditional=${
          filterIsAdditional ? "true" : "false"
        }`
      );
      return data.data.data;
    },
    {
      enabled: isActive,
    }
  );

  const {
    isLoading: isLoadingQueryDetails,
    error: errorQueryDetails,
    data: queryDetails,
  } = useQuery(
    ["queryDetails", selectedQuery],
    async () => {
      try {
        const { data } = await axios.get(
          `${ADMIN.GET_QUERY_DETAILS}/${selectedQuery?.id}`
        );

        return data.data;
      } catch (error) {
        throw new Error(`Erro ao buscar consulta: ${error.message}`);
      }
    },
    { enabled: isActive && !!selectedQuery }
  );

  const {
    isLoading: isLoadingCostBreakdown,
    error: errorCostBreakdown,
    data: costBreakdownItems,
  } = useQuery(
    ["costBreakdownByProtocol", protocolForCost],
    async () => {
      const { data } = await axios.get(ADMIN.GET_USER_QUERY_BY_PROTOCOL, {
        params: { protocol: protocolForCost },
      });
      return data?.data ?? data;
    },
    {
      enabled: openCostModal && !!protocolForCost,
    }
  );

  const totalCostBreakdown = useMemo(() => {
    if (!Array.isArray(costBreakdownItems)) return 0;
    return costBreakdownItems.reduce(
      (sum, row) => sum + Number(row?.providerPrice || 0),
      0
    );
  }, [costBreakdownItems]);

  const handleCheckboxChange = (status, setState) => {
    setState((prev) =>
      prev.includes(status)
        ? prev.filter((item) => item !== status)
        : [...prev, status]
    );
  };

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [
    activeTab,
    selectedCustomer,
    startDate,
    endDate,
    selectedProduct,
    selectedStatuses,
    filterIsAdditional, // voltar para página 1 ao mudar o filtro
  ]);

  const companyQueryPermissionMap = useMemo(() => {
    if (!Array.isArray(companyQueryPermissions)) return null;
    const map = new Map();
    companyQueryPermissions.forEach((permission) => {
      const id = Number(
        permission.QueryId ??
          permission.queryId ??
          permission.id ??
          permission.query?.id
      );
      if (Number.isNaN(id)) return;
      const price = Number(
        permission.price ??
          permission.value ??
          permission.preco ??
          permission.cost ??
          0
      );
      map.set(id, Number.isNaN(price) ? 0 : price);
    });
    return map;
  }, [companyQueryPermissions]);

  const hasRepresentativeSelected = Boolean(
    selectedRepresentative?.value != null &&
      selectedRepresentative.value !== "" &&
      Number(selectedRepresentative.value) !== 0
  );

  const customerSelectedValue = Number(selectedCustomer?.value ?? 0);
  const customerNotSelected =
    customerSelectedValue === 0 || Number.isNaN(customerSelectedValue);
  const shouldShowCompanyTableColumn =
    hasRepresentativeSelected && customerNotSelected;

  const getSimplifiedQueryId = (row) => {
    const candidates = [
      row.QueryId,
      row.queryId,
      row.id,
      row?.query?.QueryId,
      row?.query?.queryId,
      row?.query?.id,
    ];

    for (const candidate of candidates) {
      if (candidate == null) continue;
      const parsed = Number(candidate);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    return null;
  };

  const getCompanyTablePriceForRow = (row, count) => {
    if (!shouldShowCompanyTableColumn) {
      return { unitPrice: null, lineTotal: null };
    }

    const rowQueryId = getSimplifiedQueryId(row);
    if (rowQueryId == null) {
      return { unitPrice: null, lineTotal: null };
    }

    const unitPrice = companyQueryPermissionMap?.get(rowQueryId);
    if (unitPrice == null) {
      return { unitPrice: null, lineTotal: null };
    }

    const lineTotal =
      count > 0 && typeof unitPrice === "number" ? unitPrice * count : null;

    return { unitPrice, lineTotal };
  };

  useEffect(() => {
    if (!categories) return;

    const shouldFilter =
      !!companyQueryPermissionMap && companyQueryPermissionMap.size > 0;

    setListCategoryQueries(() =>
      categories.map((category) => ({
        ...category,
        Queries: (category?.Queries || []).filter((query) =>
          shouldFilter ? companyQueryPermissionMap.has(Number(query.id)) : true
        ),
      }))
    );
  }, [companyQueryPermissionMap, categories]);

  const extratoRows = Array.isArray(listReportSimplifiedQueriesAll)
    ? listReportSimplifiedQueriesAll
    : [];
  const extratoTotalTableValue = shouldShowCompanyTableColumn
    ? extratoRows.reduce((sum, row) => {
        const { lineTotal } = getCompanyTablePriceForRow(
          row,
          Number(row.count) || 0
        );
        return sum + (lineTotal ?? 0);
      }, 0)
    : 0;

  const Info = ({ label, value }) => (
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  );

  const labelize = (key = "") =>
    String(key)
      .replace(/[_-]/g, " ")
      .replace(/\b\w/g, (m) => m.toUpperCase());

  // --------- Parse e normalização seguros do `additional` ---------
  const additional = useMemo(() => {
    const raw = queryDetails?.userQuery?.data?.additional;

    if (raw == null) return null;

    let parsed = raw;
    try {
      if (typeof raw === "string") {
        const trimmed = raw.trim();
        if (!trimmed || trimmed === "null" || trimmed === "undefined") {
          return null;
        }
        parsed = parseJSON ? parseJSON(trimmed) : JSON.parse(trimmed);
      }
    } catch (e) {
      console.error("Erro ao parsear `additional`:", e, raw);
      return null;
    }

    if (Array.isArray(parsed)) return parsed;
    if (typeof parsed === "object") return parsed;
    return null;
  }, [queryDetails?.userQuery?.data?.additional]);

  // --------- Painéis principais ---------
  const panelsMain = useMemo(() => {
    const data = queryDetails?.userQuery?.data;
    if (!data || typeof data !== "object") return [];

    return Object.entries(data)
      .filter(
        ([key]) =>
          !["statusRetorno", "resumoRetorno", "additional"].includes(key)
      )
      .map(([key, item], i) => {
        if (!item) return null;
        return (
          <Accordion.Panel key={`main-${i}`}>
            <Accordion.Title className="text-sm font-medium">
              <div className="flex justify-between items-center w-full gap-2">
                <span className="text-gray-800">{key}</span>
                {item?.statusRetorno === 1 ? (
                  <Badge color="success" className="text-xs">
                    ✅ Sucesso {item?.provedorReserva && "(reserva)"}
                  </Badge>
                ) : (
                  <Badge color="failure" className="text-xs">
                    ❌ Falha
                  </Badge>
                )}
              </div>
            </Accordion.Title>

            <Accordion.Content>
              <div className="bg-gray-50 border border-gray-200 rounded-md p-4 text-sm space-y-4 text-gray-800">
                <div>
                  <p>
                    <strong>Provedor utilizado:</strong>{" "}
                    {providerNameById(item?.providerId)}{" "}
                    {item?.provedorReserva && "(reserva)"}
                  </p>
                </div>

                {Array.isArray(item?.errosAnteriores) &&
                  item.errosAnteriores.length > 0 && (
                    <div className="space-y-2">
                      <p className="font-semibold text-red-800">
                        Tentativas anteriores com erro:
                      </p>
                      {item.errosAnteriores.map((err, idx) => (
                        <div
                          key={idx}
                          className="border border-red-200 bg-red-50 rounded p-2 space-y-1"
                        >
                          <p>
                            <strong>Provedor:</strong>{" "}
                            {providerNameById(err?.providerId)}
                          </p>
                          <div className="bg-red-100 border border-red-300 text-red-900 rounded p-2 text-sm font-semibold">
                            {err?.message}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                <div>
                  <p className="font-semibold">Dados retornados:</p>
                  <pre className="whitespace-pre-wrap break-words text-xs bg-gray-100 p-2 rounded">
                    {JSON.stringify(item, null, 2)}
                  </pre>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Panel>
        );
      })
      .filter(Boolean);
  }, [queryDetails?.userQuery?.data]);

  // --------- Painéis do additional ---------
  const panelsAdditional = useMemo(() => {
    if (!additional) return [];

    if (Array.isArray(additional)) {
      return additional
        .map((item, i) => {
          if (!item) return null;
          return (
            <Accordion.Panel key={`add-arr-${i}`}>
              <Accordion.Title className="text-sm font-medium">
                <div className="flex justify-between items-center w-full gap-2">
                  <span className="text-gray-800">Adicional {i + 1}</span>
                  {item?.statusRetorno === 1 ? (
                    <Badge color="success" className="text-xs">
                      ✅ Sucesso {item?.provedorReserva && "(reserva)"}
                    </Badge>
                  ) : (
                    <Badge color="failure" className="text-xs">
                      ❌ Falha
                    </Badge>
                  )}
                </div>
              </Accordion.Title>
              <Accordion.Content>
                <div className="bg-gray-50 border border-gray-200 rounded-md p-4 text-sm space-y-4 text-gray-800">
                  <div>
                    <p>
                      <strong>Provedor utilizado:</strong>{" "}
                      {providerNameById(item?.providerId)}{" "}
                      {item?.provedorReserva && "(reserva)"}
                    </p>
                  </div>

                  {Array.isArray(item?.errosAnteriores) &&
                    item.errosAnteriores.length > 0 && (
                      <div className="space-y-2">
                        <p className="font-semibold text-red-800">
                          Tentativas anteriores com erro:
                        </p>
                        {item.errosAnteriores.map((err, idx) => (
                          <div
                            key={idx}
                            className="border border-red-200 bg-red-50 rounded p-2 space-y-1"
                          >
                            <p>
                              <strong>Provedor:</strong>{" "}
                              {providerNameById(err?.providerId)}
                            </p>
                            <div className="bg-red-100 border border-red-300 text-red-900 rounded p-2 text-sm font-semibold">
                              {err?.message}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                  <div>
                    <p className="font-semibold">Dados retornados:</p>
                    <pre className="whitespace-pre-wrap break-words text-xs bg-gray-100 p-2 rounded">
                      {JSON.stringify(item, null, 2)}
                    </pre>
                  </div>
                </div>
              </Accordion.Content>
            </Accordion.Panel>
          );
        })
        .filter(Boolean);
    }

    return Object.entries(additional)
      .map(([key, item], i) => {
        if (!item) return null;
        return (
          <Accordion.Panel key={`add-obj-${i}`}>
            <Accordion.Title className="text-sm font-medium">
              <div className="flex justify-between items-center w-full gap-2">
                <span className="text-gray-800">
                  Adicional: {labelize(key)}
                </span>
                {item?.statusRetorno === 1 ? (
                  <Badge color="success" className="text-xs">
                    ✅ Sucesso {item?.provedorReserva && "(reserva)"}
                  </Badge>
                ) : (
                  <Badge color="failure" className="text-xs">
                    ❌ Falha
                  </Badge>
                )}
              </div>
            </Accordion.Title>
            <Accordion.Content>
              <div className="bg-gray-50 border border-gray-200 rounded-md p-4 text-sm space-y-4 text-gray-800">
                <div>
                  <p>
                    <strong>Provedor utilizado:</strong>{" "}
                    {providerNameById(item?.providerId)}{" "}
                    {item?.provedorReserva && "(reserva)"}
                  </p>
                </div>

                {Array.isArray(item?.errosAnteriores) &&
                  item.errosAnteriores.length > 0 && (
                    <div className="space-y-2">
                      <p className="font-semibold text-red-800">
                        Tentativas anteriores com erro:
                      </p>
                      {item.errosAnteriores.map((err, idx) => (
                        <div
                          key={idx}
                          className="border border-red-200 bg-red-50 rounded p-2 space-y-1"
                        >
                          <p>
                            <strong>Provedor:</strong>{" "}
                            {providerNameById(err?.providerId)}
                          </p>
                          <div className="bg-red-100 border border-red-300 text-red-900 rounded p-2 text-sm font-semibold">
                            {err?.message}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                <div>
                  <p className="font-semibold">Dados retornados:</p>
                  <pre className="whitespace-pre-wrap break-words text-xs bg-gray-100 p-2 rounded">
                    {JSON.stringify(item, null, 2)}
                  </pre>
                </div>
              </div>
            </Accordion.Content>
          </Accordion.Panel>
        );
      })
      .filter(Boolean);
  }, [additional, providers]);

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <Button
          size="xs"
          onClick={() => setShowFilters((prev) => !prev)}
          className="primary text-white transition-all duration-300"
        >
          <div className="flex items-center gap-2 transition-all duration-300">
            <span>{showFilters ? "Esconder filtros" : "Mostrar filtros"}</span>
            <span className={`transition-transform duration-300 `}>
              {!showFilters ? <LuFilter /> : <LuFilterX />}
            </span>
          </div>
        </Button>
      </div>
      <div className="flex flex-col gap-4">
        {showFilters && (
          <div className="bg-white border border-gray-200 rounded-2xl shadow-md px-6 py-5 transition-all duration-500 ease-in-out">
            {(isLoadingCategories ||
              isLoadingCustomers ||
              isLoadingCompanyQueryPermissions) && <DrawerLoading />}

            <div className="text-lg font-semibold text-gray-800 mb-4">
              🎯 Filtros Avançados
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Representante */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Representante
                </label>
                <div className="h-11">
                  <AutoCompleteInput
                    options={listRepresentatives}
                    label=""
                    onChange={(representative) =>
                      setSelectedRepresentative(representative)
                    }
                    value={selectedRepresentative?.value}
                    isLoading={isLoadingListRepresentatives}
                    className="h-full"
                  />
                </div>
                {errorListCustomers && (
                  <Alert color="failure" className="mt-2">
                    Ocorreu um erro ao buscar clientes
                  </Alert>
                )}
              </div>

              {/* Cliente */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Cliente
                </label>
                <div className="h-11">
                  <AutoCompleteInput
                    options={listCustomers}
                    label=""
                    onChange={(customer) => setSelectedCustomer(customer)}
                    value={selectedCustomer?.value}
                    isLoading={isLoadingCustomers}
                    className="h-full"
                  />
                </div>
                {errorListCustomers && (
                  <Alert color="failure" className="mt-2">
                    Ocorreu um erro ao buscar clientes
                  </Alert>
                )}
              </div>

              {/* Produto */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Produto
                </label>
                <div className="h-11">
                  <AutoCompleteInput
                    options={listQueries}
                    label=""
                    onChange={(product) => setSelectedProduct(product)}
                    value={selectedProduct?.value}
                    isLoading={isLoadingQueries}
                    className="h-full"
                  />
                </div>
                {errorQueries && (
                  <Alert color="failure" className="mt-2">
                    Ocorreu um erro ao buscar clientes
                  </Alert>
                )}
              </div>

              {/* Período */}
              <div className="flex flex-col md:col-span-2">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Período
                </label>
                <div className="flex gap-2 items-center h-11">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      if (moment(e.target.value).isAfter(moment(endDate))) {
                        setEndDate(e.target.value);
                      }
                    }}
                    className="w-full h-full bg-gray-50 border border-gray-300 text-sm rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="text-sm text-gray-500">até</span>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    min={startDate}
                    className="w-full h-full bg-gray-50 border border-gray-300 text-sm rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>

              {/* Status */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Status da Consulta
                </label>
                <div className="flex gap-2 h-11">
                  <button
                    type="button"
                    onClick={() => handleCheckboxChange(1, setSelectedStatuses)}
                    className={`h-full px-4 rounded-lg text-sm font-medium border transition w-full ${
                      selectedStatuses.includes(1)
                        ? "bg-green-100 text-green-700 border-green-300"
                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    ✅ Sucesso
                  </button>
                  <button
                    type="button"
                    onClick={() => handleCheckboxChange(0, setSelectedStatuses)}
                    className={`h-full px-4 rounded-lg text-sm font-medium border transition w-full ${
                      selectedStatuses.includes(0)
                        ? "bg-red-100 text-red-700 border-red-300"
                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    ❌ Falha
                  </button>
                </div>
              </div>

              {/* NOVO: Filtro "É adicional?" */}
              <div className="flex items-center gap-3">
                <input
                  id="filter-additional"
                  type="checkbox"
                  checked={filterIsAdditional}
                  onChange={(e) => setFilterIsAdditional(e.target.checked)}
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                />
                <label
                  htmlFor="filter-additional"
                  className="text-sm font-medium text-gray-700"
                >
                  Mostrar somente consultas adicionais
                </label>
              </div>
            </div>
          </div>
        )}

        <div
          className="flex-1 overflow-x-scroll print-padding print-content"
          ref={reportRef}
        >
          <div className="title-syncx mt-3 mb-4">Resultado da busca</div>
          {startDate && endDate && (
            <div className="italic text-sm mb-2 flex items-center gap-2">
              Informações baseadas no período de{" "}
              <Badge className="w-fit">
                {moment(startDate).format("DD/MM/yyyy")}
              </Badge>{" "}
              até{" "}
              <Badge className="w-fit">
                {" "}
                {moment(endDate).format("DD/MM/yyyy")}
              </Badge>
            </div>
          )}

          <div className="overflow-x-auto">
            <div className="flex gap-4 pb-3 min-w-[800px]">
              {/* Valor Total */}
              <div className="min-w-[250px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#1A387F] to-[#3C39B3] relative">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Valor Total</p>
                    <h2 className="text-2xl font-bold mt-1">
                      {!isLoadingReportQueries &&
                      !isFetchingReportQueries &&
                      !isFetchingReportSimplifiedQueries ? (
                        formatToReal(totalPriceSum)
                      ) : (
                        <div className="animate-pulse h-6 bg-white/30 rounded w-28" />
                      )}
                    </h2>
                  </div>
                  <MdOutlineAttachMoney className="text-white text-4xl opacity-20" />
                </div>
              </div>

              {userPermission === "POWER_USER" && (
                <div className="min-w-[250px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#1A387F] to-[#3C39B3] relative">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm opacity-90">Valor Total/Custo</p>
                      <h2 className="text-2xl font-bold mt-1">
                        {!isLoadingReportQueries &&
                        !isFetchingReportQueries &&
                        !isFetchingReportSimplifiedQueries ? (
                          formatToReal(totalCostPrice)
                        ) : (
                          <div className="animate-pulse h-6 bg-white/30 rounded w-28" />
                        )}
                      </h2>
                    </div>
                    <MdOutlineAttachMoney className="text-white text-4xl opacity-20" />
                  </div>
                </div>
              )}

              {/* Total de Consultas */}
              <div className="min-w-[220px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#0F766E] to-[#14B8A6] relative">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Total de Consultas</p>
                    <h2 className="text-2xl font-bold mt-1">
                      {!isLoadingReportQueries &&
                      !isFetchingReportQueries &&
                      !isFetchingReportSimplifiedQueries ? (
                        totalCount >= 1000 ? (
                          totalCount.toLocaleString("pt-BR")
                        ) : (
                          totalCount
                        )
                      ) : (
                        <div className="animate-pulse h-6 bg-white/30 rounded w-24" />
                      )}
                    </h2>
                  </div>
                  <BsFillBarChartFill className="text-white text-4xl opacity-20" />
                </div>
              </div>

              {selectedRepresentative?.value != 0 &&
                selectedRepresentative?.value != 1 && (
                  <div className="min-w-[220px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#0F766E] to-[#14B8A6] relative">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm opacity-90">Valor de custo</p>
                        <h2 className="text-2xl font-bold mt-1">
                          {!isLoadingReportQueries &&
                          !isFetchingReportQueries &&
                          !isFetchingReportSimplifiedQueries ? (
                            formatToReal(totalPriceBase)
                          ) : (
                            <div className="animate-pulse h-6 bg-white/30 rounded w-24" />
                          )}
                        </h2>
                      </div>
                      <BsFillBarChartFill className="text-white text-4xl opacity-20" />
                    </div>
                  </div>
                )}

              {/* VCM ou Saldo */}
              {selectedCustomer?.value !== 0 && (
                <div
                  className={`min-w-[220px] flex-1 rounded-2xl p-4 shadow-md text-white relative ${
                    selectedCustomer?.typePayment === "POS"
                      ? "bg-gradient-to-br from-[#7C3AED] to-[#8B5CF6]"
                      : "bg-gradient-to-br from-[#B45309] to-[#F59E0B]"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm opacity-90">
                        {selectedCustomer?.typePayment === "POS"
                          ? "Consumação Mínima (VCM)"
                          : "Saldo Atual"}
                      </p>
                      <h2 className="text-2xl font-bold mt-1">
                        {selectedCustomer?.typePayment === "POS"
                          ? selectedCustomer?.vcm
                            ? formatToReal(selectedCustomer?.vcm)
                            : "-"
                          : formatToReal(selectedCustomer?.credit)}
                      </h2>
                    </div>
                    <MdOutlineAttachMoney className="text-white text-4xl opacity-20" />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="mb-4 mt-2 flex flex-col md:flex-row  justify-between items-end md:items-center gap-2">
            <div className="flex gap-2 items-center">
              <Button className="bg-gray-500" onClick={reactToPrintFn}>
                <div className="flex gap-2 items-center">
                  <div>Imprimir</div>
                  <MdLocalPrintshop fontSize={20} />
                </div>
              </Button>
              {activeTab === 1 && (
              <Button
                color="light"
                onClick={reactToPrintExtrato}
                disabled={
                  isLoadingReportSimplifiedQueries ||
                  isFetchingReportSimplifiedQueries ||
                  isFetchingReportSimplifiedQueriesAll ||
                  !listReportSimplifiedQueriesAll?.length
                }
              >
                  <div className="flex gap-2 items-center">
                    <div>Salvar como extrato</div>
                    <MdReceiptLong fontSize={18} />
                  </div>
                </Button>
              )}
            </div>
            <div className="flex gap-2 items-center">
              <div className="text-xs font-semibold">Visualizar relatório:</div>
              <ul className="text-sm rounded-md border border-gray-300 flex">
                <li
                  className={`py-2 px-4 rounded-md cursor-pointer ${
                    activeTab === 1
                      ? `bg-primary text-white font-semibold shadow-md`
                      : `bg-white`
                  }`}
                  onClick={() => setActiveTab(1)}
                >
                  Simplificado
                </li>
                <li
                  className={`py-2 px-4 rounded-md cursor-pointer ${
                    activeTab === 0
                      ? `bg-primary text-white font-semibold shadow-md`
                      : `bg-white`
                  }`}
                  onClick={() => setActiveTab(0)}
                >
                  Detalhado
                </li>
              </ul>
            </div>
          </div>

          {activeTab === 0 && (
            <form
              className="flex gap-1 mt-0 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
              onSubmit={handleSearchName}
            >
              <input
                type="text"
                placeholder="Busque por parâmetro da consulta..."
                className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
                onChange={(e) => setSearchName(e.target.value)}
                value={searchName}
              />
              <Button
                size="sm"
                className="flex items-center bg-secondary w-20"
                type="submit"
              >
                <IoMdSearch />
              </Button>
            </form>
          )}

          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>

          {/* ======== Detalhado ======== */}
          {activeTab === 0 && (
            <>
              {listReportQueries?.length > 0 || isLoadingReportQueries ? (
                <div className="mt-3 rounded-xl border border-gray-200 shadow-sm overflow-hidden bg-white">
                  <div className="flex items-center justify-between gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200">
                    <div className="text-sm font-semibold text-gray-800">
                      Relatório Detalhado
                    </div>
                  </div>

                  <div className="divide-y divide-gray-100">
                    {!isLoadingReportQueries ? (
                      listReportQueries?.map((query, index) => {
                        const created = moment(query.createdAt);
                        const statusOk = !!query.isSuccess;
                        const priceBase = Number(query?.priceBase || 0);
                        const priceFinal = Number(query?.price || 0);
                        const totalCostValue = Number(
                          query?.totalCostPrice || 0
                        );
                        const marginPercent =
                          totalCostValue > 0
                            ? -(1 - priceBase / totalCostValue) * 100
                            : null;

                        return (
                          <div
                            key={index}
                            className={[
                              "relative border-b border-gray-200 bg-white px-3 py-2 mb-0.5",
                              "shadow-sm transition-all hover:ring-1 hover:ring-gray-300",
                            ].join(" ")}
                          >
                            <span
                              className={[
                                "absolute left-0 top-0 h-full w-[3px]",
                                statusOk
                                  ? "bg-gradient-to-b from-emerald-500 to-emerald-600"
                                  : "bg-gradient-to-b from-rose-500 to-rose-600",
                              ].join(" ")}
                            />

                            <div className="flex items-start gap-3">
                              <div className="text-[10px] text-gray-500 flex flex-col gap-0.5 mt-1">
                                <span className="font-semibold text-gray-700">
                                  {created.format("DD/MM/YY")}
                                </span>
                                <span>{created.format("HH:mm")}h</span>
                              </div>

                              <div className="flex-1 min-w-0 space-y-1">
                                <div className="flex items-center gap-2 text-sm font-semibold text-gray-900">
                                  <span
                                    className="truncate"
                                    title={query.queryName}
                                  >
                                    {query.queryName}
                                  </span>
                                  {query?.hasIA ? (
                                    <span className="text-[10px] uppercase tracking-wide bg-blue-100 text-blue-700 rounded-full px-2 py-0.5">
                                      +IA
                                    </span>
                                  ) : null}
                                </div>
                                <div className="flex flex-wrap items-center gap-3 text-[11px] text-slate-500">
                                  {!!query?.protocol && (
                                    <span className="flex items-center gap-1">
                                      <span className="font-semibold text-gray-700">
                                        Protocolo:
                                      </span>
                                      <span>{query.protocol}</span>
                                    </span>
                                  )}
                                  <span className="flex items-center gap-1">
                                    <span className="font-semibold text-gray-700">
                                      Parâmetro:
                                    </span>
                                    <span>{query.parameter || "-"}</span>
                                  </span>
                                </div>
                              </div>
                              <div className="flex flex-col items-end text-right text-[11px] text-gray-600 gap-1">
                                <div className="flex items-baseline gap-3">
                                  {userPermission === "POWER_USER" && (
                                    <span className="font-semibold text-rose-600 text-[12px]">
                                      Vl. Custo: {formatToReal(totalCostValue)}
                                    </span>
                                  )}
                                  <span
                                    className={`font-semibold text-[12px] ${
                                      userPermission === "POWER_USER"
                                        ? "text-gray-400"
                                        : "text-red-500"
                                    }`}
                                  >
                                    {userPermission === "POWER_USER"
                                      ? "Vl. venda"
                                      : "Custo"}
                                    : {formatToReal(priceBase)}
                                  </span>

                                  <span
                                    className={`font-semibold text-[12px] text-green-500`}
                                  >
                                    Vl. Final: {formatToReal(priceFinal)}
                                  </span>
                                  {userPermission === "POWER_USER" && (
                                    <span
                                      className={`text-[12px] font-semibold ${
                                        marginPercent < 10
                                          ? "text-rose-600"
                                          : "text-emerald-600"
                                      }`}
                                    >
                                      (Margem: {marginPercent?.toFixed(1) || 0}
                                      %)
                                    </span>
                                  )}
                                </div>
                                <div className="flex flex-wrap gap-2 text-[12px] text-gray-500">
                                  <span className="max-w-[320px] truncate flex items-center gap-1">
                                    <MdPersonSearch size={13} />
                                    {query?.companyName || "-"}
                                  </span>
                                  <span className="max-w-[320px] truncate">
                                    <span className="font-semibold text-gray-700">
                                      Usuário:
                                    </span>{" "}
                                    {query.userName || "-"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="mt-2 flex items-center justify-between text-[11px] text-gray-500">
                              <div className="flex items-center gap-1">
                                <span
                                  className={`flex items-center justify-center rounded-full text-[10px] px-2 py-0.5 font-semibold ${
                                    query.hasRestrictions
                                      ? "bg-rose-100 text-rose-700"
                                      : "bg-emerald-100 text-emerald-700"
                                  }`}
                                  title={
                                    query.hasRestrictions
                                      ? "Com restrição"
                                      : "Sem restrição"
                                  }
                                >
                                  {query.hasRestrictions ? (
                                    <div className="flex items-center gap-1">
                                      <MdErrorOutline size={12} />
                                      <span>Documento com Restrições</span>
                                    </div>
                                  ) : (
                                    <div className="flex items-center gap-1">
                                      <IoIosCheckmarkCircleOutline size={12} />
                                      <span>Documento sem Restrições</span>
                                    </div>
                                  )}
                                </span>
                              </div>
                              <div className="flex items-center gap-1 text-gray-600">
                                {!!query?.isSuccess && !query.isModular && (
                                  <button
                                    type="button"
                                    className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                    title="Visualizar consulta"
                                    onClick={() => {
                                      setSelectedQueryReview(query);
                                      setDataQuery(query.data);
                                      setOpenModal(true);
                                    }}
                                  >
                                    <MdOutlinePageview fontSize={16} />
                                  </button>
                                )}
                                {userPermission === "POWER_USER" && (
                                  <>
                                    {!!query?.protocol && (
                                      <button
                                        type="button"
                                        className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                        title="Detalhar custo (protocolo)"
                                        onClick={() => {
                                          setProtocolForCost(query.protocol);
                                          setOpenCostModal(true);
                                        }}
                                      >
                                        <MdReceiptLong fontSize={16} />
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                      title="Detalhes técnicos"
                                      onClick={() => {
                                        setSelectedQuery(query);
                                        setOpenModalViewDetails(true);
                                      }}
                                    >
                                      <MdOutlineDisplaySettings fontSize={16} />
                                    </button>
                                    <button
                                      type="button"
                                      className="p-1 rounded-full border border-gray-200 text-gray-600 hover:border-gray-300 transition"
                                      title="Editar preço"
                                      onClick={() => {
                                        setQueryToEdit(query);
                                        setNewPrice(query?.price || "");
                                        setEditPriceModalOpen(true);
                                      }}
                                    >
                                      <MdEdit fontSize={16} />
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div>
                        <div className="p-1 space-y-2">
                          {Array.from({ length: 16 }).map((_, i) => (
                            <div
                              key={i}
                              className="relative px-2.5 py-1.5 rounded-lg mx-1 my-[3px] ring-1 ring-transparent"
                            >
                              <span className="absolute left-0 top-0 h-full w-[3px] bg-gray-200 rounded-l-lg" />
                              <div className="flex items-center gap-2">
                                <div className="shrink-0">
                                  <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                                <div className="min-w-0 flex-1">
                                  <div className="h-4 w-2/3 bg-gray-200 rounded animate-pulse" />
                                </div>
                                <div className="shrink-0 flex items-center gap-2">
                                  <div className="h-5 w-24 bg-gray-200 rounded-full animate-pulse" />
                                  <div className="h-4 w-12 bg-gray-200 rounded animate-pulse" />
                                </div>
                                <div className="w-[82px] shrink-0">
                                  <div className="h-5 bg-gray-200 rounded animate-pulse" />
                                </div>
                                <div className="shrink-0 flex items-center gap-1">
                                  <div className="h-6 w-6 bg-gray-200 rounded animate-pulse" />
                                  <div className="h-6 w-6 bg-gray-200 rounded animate-pulse" />
                                  <div className="h-6 w-6 bg-gray-200 rounded animate-pulse" />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          )}

          {/* ======== Simplificado ======== */}
          {activeTab === 1 && (
            <>
              {listReportSimplifiedQueries?.length > 0 ||
              isLoadingReportSimplifiedQueries ||
              isFetchingReportSimplifiedQueries ? (
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm mt-3">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 p-3">
                    <div className="text-sm font-semibold text-gray-800">
                      {filterIsAdditional
                        ? "Distribuição por adicional"
                        : "Distribuição por consulta"}
                    </div>

                    {/* Botões: count | value (sem "adicional", pois virou filtro) */}
                    <div className="inline-flex rounded-md overflow-hidden border border-gray-300">
                      <button
                        type="button"
                        onClick={() => setBarMetric("count")}
                        className={`px-2.5 py-1 text-xs ${
                          barMetric === "count"
                            ? "bg-blue-800 text-white"
                            : "bg-white text-gray-700"
                        }`}
                      >
                        Por quantidade
                      </button>
                      <button
                        type="button"
                        onClick={() => setBarMetric("value")}
                        className={`px-2.5 py-1 text-xs ${
                          barMetric === "value"
                            ? "bg-blue-800 text-white"
                            : "bg-white text-gray-700"
                        }`}
                      >
                        Por valor
                      </button>
                    </div>
                  </div>

                  <div className="divide-y divide-gray-100 mt-3">
                    {!isLoadingReportSimplifiedQueries &&
                    !isFetchingReportSimplifiedQueries
                      ? (() => {
                          const denomCount = Number(totalCount) || 0;
                          const denomValue = Number(totalPriceSum) || 0;

                          const rows = [
                            ...(listReportSimplifiedQueries || []),
                          ].sort((a, b) => {
                            const av =
                              barMetric === "value"
                                ? Number(a.totalPrice || 0)
                                : Number(a.count || 0);
                            const bv =
                              barMetric === "value"
                                ? Number(b.totalPrice || 0)
                                : Number(b.count || 0);
                            return bv - av;
                          });

                          return rows.map((q, idx) => {
                            const count = Number(q.count) || 0;
                            const value = Number(q.totalPrice || 0) || 0;

                            const percent =
                              barMetric === "value"
                                ? denomValue > 0
                                  ? (value / denomValue) * 100
                                  : 0
                                : denomCount > 0
                                ? (count / denomCount) * 100
                                : 0;

                            const displayName = filterIsAdditional
                              ? q.additionalName || q.queryName
                              : q.queryName;

                            const subtitle = filterIsAdditional
                              ? "Adicional"
                              : "Consulta";

                            const {
                              unitPrice: companyUnitPrice,
                              lineTotal: companyLineTotalPrice,
                            } = getCompanyTablePriceForRow(q, count);

                            return (
                              <div key={idx} className="px-3 py-1">
                                <div className="flex items-center justify-between gap-2">
                                  <div className="min-w-0">
                                    <div
                                      className="text-[13px] font-semibold text-gray-900 truncate"
                                      title={displayName}
                                    >
                                      {displayName}
                                    </div>
                                    <div className="text-[10px] text-gray-500">
                                      {subtitle}
                                    </div>
                                  </div>

                                  <div className="flex items-end gap-3 shrink-0 text-[12px]">
                                    <div className="text-right leading-tight">
                                      <div className="font-bold text-blue-700">
                                        {count >= 1000
                                          ? count.toLocaleString("pt-BR")
                                          : count}
                                      </div>
                                      <div className="text-[10px] text-gray-500">
                                        Qtd.
                                      </div>
                                    </div>
                                    <div className="text-right leading-tight">
                                      <div className="font-bold text-green-700">
                                        {formatToReal(value)}
                                      </div>
                                      <div className="text-[10px] text-gray-500">
                                        Valor
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Barra */}
                                <div className="mt-1.5">
                                  <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden">
                                    <div
                                      className={`h-2 rounded-full transition-all duration-500 ${
                                        barMetric === "value"
                                          ? "bg-gradient-to-r from-emerald-600 to-green-500"
                                          : "bg-gradient-to-r from-blue-600 to-cyan-500"
                                      }`}
                                      style={{
                                        width: `${Math.min(
                                          100,
                                          Math.max(0, percent)
                                        ).toFixed(2)}%`,
                                      }}
                                    />
                                  </div>
                                  <div className="mt-0.5 text-[10px] text-gray-500 flex gap-4">
                                    {percent.toFixed(1)}% do total{" "}
                                    {barMetric === "value"
                                      ? "em valor"
                                      : "de consultas"}
                                    {shouldShowCompanyTableColumn &&
                                      companyLineTotalPrice != null && (
                                      <div className="text-[10px] text-gray-500">
                                        Valor da tabela (Representante):{" "}
                                        <span className="font-semibold text-gray-900">
                                          {formatToReal(companyUnitPrice)}
                                        </span>{" "}
                                        × {count} ={" "}
                                        <span className="font-semibold text-gray-900">
                                          {formatToReal(companyLineTotalPrice)}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          });
                        })()
                      : Array.from({ length: 6 }).map((_, i) => (
                          <div key={i} className="p-3 animate-pulse">
                            <div className="flex items-center justify-between">
                              <div className="h-3.5 bg-gray-200 rounded w-2/3" />
                              <div className="flex gap-3">
                                <div className="h-3.5 bg-gray-200 rounded w-8" />
                                <div className="h-3.5 bg-gray-200 rounded w-16" />
                              </div>
                            </div>
                            <div className="h-2 bg-gray-200 rounded-full mt-2" />
                          </div>
                        ))}
                  </div>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          )}
        </div>

        {totalPages > 1 && (
          <div className="flex overflow-x-auto justify-center">
            <Pagination
              layout="pagination"
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
              previousLabel=""
              nextLabel=""
              showIcons
            />
          </div>
        )}

        {/* Extrato para impressão (baseado em listReportSimplifiedQueries) */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-9999px",
            width: "100%",
            backgroundColor: "#F3F4F6",
            padding: "32px 0",
          }}
        >
          <div
            ref={extratoRef}
            style={{
              width: "900px",
              margin: "0 auto",
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "24px 28px",
              boxSizing: "border-box",
            }}
          >
            {/* Cabeçalho */}
            <header style={{ marginBottom: "16px" }}>
              <h1
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#111827",
                  marginBottom: "4px",
                }}
              >
                Extrato de Consultas
              </h1>

              {/* Nome do cliente em destaque */}
              <p
                style={{
                  fontSize: "13px",
                  color: "#111827",
                  marginBottom: "2px",
                }}
              >
                <strong>Cliente: </strong>
                {selectedCustomer?.value === 0
                  ? "Todos os clientes"
                  : selectedCustomer?.label || "-"}
              </p>

              {/* Representante (se tiver) */}
              {selectedRepresentative?.value ? (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#4B5563",
                    marginBottom: "2px",
                  }}
                >
                  Representante:{" "}
                  <strong>{selectedRepresentative?.label || "-"}</strong>
                </p>
              ) : null}

              {/* Período */}
              {startDate && endDate ? (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#4B5563",
                    marginBottom: "2px",
                  }}
                >
                  Período:{" "}
                  <strong>{moment(startDate).format("DD/MM/YYYY")}</strong> até{" "}
                  <strong>{moment(endDate).format("DD/MM/YYYY")}</strong>
                </p>
              ) : null}

              {/* Emitido em */}
              <p
                style={{
                  fontSize: "11px",
                  color: "#6B7280",
                  marginTop: "4px",
                  marginBottom: "0",
                }}
              >
                Emitido em {moment().format("DD/MM/YYYY HH:mm")}h
              </p>
            </header>

            {/* Resumo em chips */}
            <section
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                marginTop: "16px",
                marginBottom: "18px",
              }}
            >
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px 10px",
                  borderRadius: "999px",
                  backgroundColor: "#EFF6FF",
                  border: "1px solid #DBEAFE",
                  fontSize: "11px",
                  color: "#1D4ED8",
                }}
              >
                <span style={{ fontWeight: 600 }}>Visão:</span>
                <span>
                  {filterIsAdditional ? "Adicionais" : "Consultas"} ·{" "}
                  {barMetric === "value" ? "por valor" : "por quantidade"}
                </span>
              </div>

              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px 10px",
                  borderRadius: "999px",
                  backgroundColor: "#ECFDF3",
                  border: "1px solid #BBF7D0",
                  fontSize: "11px",
                  color: "#166534",
                }}
              >
                <span style={{ fontWeight: 600 }}>Total de consultas:</span>
                <span>
                  {totalCount?.toLocaleString?.("pt-BR") ?? totalCount ?? 0}
                </span>
              </div>

              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px 10px",
                  borderRadius: "999px",
                  backgroundColor: "#FFFBEB",
                  border: "1px solid #FEF3C7",
                  fontSize: "11px",
                  color: "#92400E",
                }}
              >
                <span style={{ fontWeight: 600 }}>Valor total:</span>
                <span>{formatToReal(totalPriceSum)}</span>
              </div>
            </section>

            {/* Tabela */}
            <section>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "11px",
                  marginTop: "4px",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        padding: "8px 6px",
                        textAlign: "left",
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: "#F9FAFB",
                        fontWeight: 600,
                        color: "#374151",
                      }}
                    >
                      Consulta
                    </th>
                    <th
                      style={{
                        padding: "8px 6px",
                        textAlign: "left",
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: "#F9FAFB",
                        fontWeight: 600,
                        color: "#374151",
                        width: "90px",
                      }}
                    >
                      Tipo
                    </th>
                    <th
                      style={{
                        padding: "8px 6px",
                        textAlign: "right",
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: "#F9FAFB",
                        fontWeight: 600,
                        color: "#374151",
                        width: "80px",
                      }}
                    >
                      Qtd.
                    </th>
                    {shouldShowCompanyTableColumn && (
                      <th
                        style={{
                          padding: "8px 6px",
                          textAlign: "right",
                          borderBottom: "1px solid #E5E7EB",
                          backgroundColor: "#F9FAFB",
                          fontWeight: 600,
                          color: "#374151",
                          width: "110px",
                        }}
                      >
                        Valor da tabela
                      </th>
                    )}
                    <th
                      style={{
                        padding: "8px 6px",
                        textAlign: "right",
                        borderBottom: "1px solid #E5E7EB",
                        backgroundColor: "#F9FAFB",
                        fontWeight: 600,
                        color: "#374151",
                        width: "110px",
                      }}
                    >
                      Valor total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(extratoRows) &&
                    (() => {
                      const denomCount = Number(totalCount) || 0;
                      const denomValue = Number(totalPriceSum) || 0;

                      const rows = [...extratoRows].sort(
                        (a, b) => {
                          const av =
                            barMetric === "value"
                              ? Number(a.totalPrice || 0)
                              : Number(a.count || 0);
                          const bv =
                            barMetric === "value"
                              ? Number(b.totalPrice || 0)
                              : Number(b.count || 0);
                          return bv - av;
                        }
                      );

                      return rows.map((q, idx) => {
                        const count = Number(q.count) || 0;
                        const value = Number(q.totalPrice || 0) || 0;

                        const percent =
                          barMetric === "value"
                            ? denomValue > 0
                              ? (value / denomValue) * 100
                              : 0
                            : denomCount > 0
                            ? (count / denomCount) * 100
                            : 0;

                        const displayName = filterIsAdditional
                          ? q.additionalName || q.queryName
                          : q.queryName;

                        const subtitle = filterIsAdditional
                          ? "Adicional"
                          : "Consulta";

                        const {
                          unitPrice: companyUnitPrice,
                          lineTotal: companyLineTotalPrice,
                        } = getCompanyTablePriceForRow(q, count);

                        return (
                          <tr
                            key={idx}
                            style={{
                              backgroundColor:
                                idx % 2 === 0 ? "white" : "#F9FAFB",
                            }}
                          >
                            <td
                              style={{
                                padding: "6px",
                                borderBottom: "1px solid #F3F4F6",
                                maxWidth: "260px",
                                wordBreak: "break-word",
                                color: "#111827",
                              }}
                            >
                              {displayName}
                            </td>
                            <td
                              style={{
                                padding: "6px",
                                borderBottom: "1px solid #F3F4F6",
                                color: "#4B5563",
                              }}
                            >
                              {subtitle}
                            </td>
                            <td
                              style={{
                                padding: "6px",
                                borderBottom: "1px solid #F3F4F6",
                                textAlign: "right",
                                color: "#111827",
                              }}
                            >
                              {count >= 1000
                                ? count.toLocaleString("pt-BR")
                                : count}
                            </td>
                            {shouldShowCompanyTableColumn && (
                              <td
                                style={{
                                  padding: "6px",
                                  borderBottom: "1px solid #F3F4F6",
                                  textAlign: "right",
                                  color: "#064E3B",
                                  fontWeight: 600,
                                }}
                              >
                                {companyLineTotalPrice != null
                                  ? formatToReal(companyLineTotalPrice)
                                  : "-"}
                              </td>
                            )}
                            <td
                              style={{
                                padding: "6px",
                                borderBottom: "1px solid #F3F4F6",
                                textAlign: "right",
                                color: "#16A34A",
                                fontWeight: 600,
                              }}
                            >
                              {formatToReal(value)}
                            </td>
                          </tr>
                        );
                      });
                    })()}
                </tbody>
              </table>
              {shouldShowCompanyTableColumn && (
                <div
                  style={{
                    marginTop: "12px",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "8px",
                    alignItems: "baseline",
                    fontSize: "12px",
                    color: "#064E3B",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Valor Total Tabela:</span>
                  <span style={{ fontWeight: 600 }}>
                    {formatToReal(extratoTotalTableValue)}
                  </span>
                </div>
              )}
            </section>
          </div>
        </div>

        <Modal
          show={openModalViewDetails}
          size="4xl"
          onClose={() => setOpenModalViewDetails(false)}
          popup
          className="relative"
        >
          <Modal.Header />
          <Modal.Body>
            <Tabs
              aria-label="Tabs de Detalhes"
              onActiveTabChange={(tabIndex) => setActiveTabModal(tabIndex)}
            >
              <TabItem active={activeTabModal === 0} title="Informações">
                <div className="space-y-6">
                  <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">
                      Resumo da Consulta
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">
                      <Info label="Consulta" value={selectedQuery?.queryName} />
                      <Info
                        label="Data e Hora"
                        value={
                          moment(selectedQuery?.createdAt).format(
                            "DD/MM/yyyy | HH:mm"
                          ) + "h"
                        }
                      />
                      <Info
                        label="IP"
                        value={queryDetails?.userQuery?.ip || "-"}
                      />
                      <Info
                        label="Parâmetro Informado"
                        value={selectedQuery?.parameter}
                      />
                      <Info
                        label="Tempo de resposta"
                        value={
                          queryDetails?.userQuery?.executionTime
                            ? `${queryDetails?.userQuery?.executionTime}s`
                            : "-"
                        }
                      />
                      <Info label="Usuário" value={selectedQuery?.userName} />
                      <Info
                        label="Preço"
                        value={formatToReal(selectedQuery?.price || 0)}
                      />
                      <div className="flex items-center gap-2">
                        <span className="font-semibold">Status:</span>
                        {selectedQuery?.isSuccess ? (
                          <Badge color="success">✅ Sucesso</Badge>
                        ) : (
                          <Badge color="failure">❌ Falha</Badge>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </TabItem>

              <TabItem active={activeTabModal === 1} title="Status">
                <div className="max-h-[500px] overflow-y-auto space-y-3 px-1">
                  {queryDetails?.userQuery?.data ? (
                    <Accordion collapseAll>
                      {panelsMain}
                      {panelsAdditional}
                    </Accordion>
                  ) : (
                    <p className="text-sm text-center text-gray-500 py-4">
                      Nenhum log encontrado.
                    </p>
                  )}
                </div>
              </TabItem>
            </Tabs>
          </Modal.Body>
          {isLoadingQueryDetails && <DrawerLoading />}
        </Modal>

        <Modal show={openModal} onClose={() => setOpenModal(false)} size="4xl">
          <ModalHeader>Visualizar consulta</ModalHeader>
          <ModalBody className="bg-gray-100">
            {!isOlderThan30Days(selectedQueryReview?.createdAt) ? (
              <>
                <div className="review-query" ref={printRef}>
                  {selectedQueryReview?.categoryId === 1 && (
                    <CustomCreditQueryReview
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                  {selectedQueryReview?.categoryId === 2 && (
                    <CustomCadastralQueryReview
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                  {selectedQueryReview?.categoryId === 3 && (
                    <CustomVehicleQueryReview
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                </div>
              </>
            ) : (
              <div className="bg-gray-50 p-2 rounded-md border border-gray-300 rounded-md">
                A consulta não está mais disponível para visualização em nossa
                base de dados, possivelmente por ter ultrapassado o período de
                retenção (30 dias) ou por políticas de conformidade. Se precisar
                reavaliar, recomendamos gerar uma nova consulta.
              </div>
            )}
          </ModalBody>
          <ModalFooter className="flex justify-center">
            <Button onClick={() => reactToPrintFnQuery()}>Imprimir</Button>
            <Button color="gray" onClick={() => setOpenModal(false)}>
              Fechar
            </Button>
          </ModalFooter>
        </Modal>

        <ModalEditPrice
          isOpen={editPriceModalOpen}
          initialPrice={newPrice}
          onClose={() => {
            setEditPriceModalOpen(false);
            setQueryToEdit(null);
          }}
          onSave={async (parsedPrice) => {
            try {
              await axios.put(
                `${ADMIN.UPDATE_QUERY_PRICE}/${queryToEdit?.id}`,
                {
                  price: parsedPrice,
                }
              );
              queryClient.invalidateQueries("listReportQueries");
              setEditPriceModalOpen(false);
              setQueryToEdit(null);
            } catch (error) {
              alert("Erro ao atualizar preço");
            }
          }}
        />

        <Modal
          show={openCostModal}
          onClose={() => {
            setOpenCostModal(false);
            setProtocolForCost(null);
          }}
          size="2xl"
          popup
        >
          <ModalHeader className="px-4 mb-4">
            Detalhe de custo da consulta
          </ModalHeader>
          <ModalBody>
            {isLoadingCostBreakdown ? (
              <div className="flex items-center justify-center py-8">
                <Spinner />
              </div>
            ) : errorCostBreakdown ? (
              <Alert color="failure">
                Ocorreu um erro ao carregar o detalhamento de custos.
              </Alert>
            ) : Array.isArray(costBreakdownItems) &&
              costBreakdownItems.length > 0 ? (
              <div className="space-y-3">
                <div className="rounded-xl border border-gray-200 overflow-hidden">
                  <Table striped>
                    <Table.Head>
                      <Table.HeadCell className="bg-gray-100">
                        Módulo
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-100">
                        Custo
                      </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                      {costBreakdownItems.map((row, idx) => (
                        <Table.Row key={idx} className="bg-white">
                          <Table.Cell className="font-medium">
                            {row?.name || "-"}
                          </Table.Cell>
                          <Table.Cell className="text-center">
                            {formatToReal(row?.providerPrice || 0)}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>

                <div className="flex justify-center">
                  <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 bg-gray-100 border border-gray-200">
                    <span className="text-xs text-gray-600">
                      Total de custo
                    </span>
                    <span className="text-sm font-semibold">
                      {formatToReal(totalCostBreakdown)}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <EmptyTable icon="search_off">
                Nenhum item encontrado para este protocolo.
              </EmptyTable>
            )}
          </ModalBody>
          <ModalFooter className="flex justify-center">
            <Button color="gray" onClick={() => setOpenCostModal(false)}>
              Fechar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default AdminHistoryTable;
